import { useSettings } from '@capsicum/common';

import { type HeaderWarningPage, type UkRiskLinkKeys } from '../models';

export const useShowHeaderWarning = (isGatewayPage?: boolean) => {
	const {
		settings: { ukRiskLink, ukRiskLinkVisibility, ukRiskWarning }
	} = useSettings(isGatewayPage);

	const shouldShowHeaderWarning = (page: HeaderWarningPage) => ukRiskWarning[page];
	const shouldShowUkRiskLink = (key: UkRiskLinkKeys) => ukRiskLinkVisibility[key];

	return {
		riskLink: ukRiskLink,
		shouldShowHeaderWarning,
		shouldShowUkRiskLink
	};
};
